import {
  CreateEquipmentCommand,
  EquipmentDto,
  EquipmentType,
  UpdateEquipmentCommand,
  YardBlockAssignmentDto,
} from '@operations/app/api'
import { EquipmentFormProfile } from './equipment-form.profile'

const mapFormValuesToCreateDto = ({
  name,
  description,
  equipmentType,
  isActive,
  maxStackingHeight,
  maxLiftWeight,
  yardBlockAssignments,
  isOwned,
}: EquipmentFormProfile): CreateEquipmentCommand => ({
  name,
  description,
  equipmentType: equipmentType as EquipmentType,
  isActive,
  yardBlockAssignments: yardBlockAssignments ?? [],
  maxStackingHeight,
  maxLiftWeight,
  isOwned,
})

const mapFormValuesToUpdateDto = ({
  id,
  name,
  description,
  isActive,
  maxStackingHeight,
  maxLiftWeight,
  yardBlockAssignments,
  isOwned,
}: EquipmentFormProfile): UpdateEquipmentCommand => ({
  id: id!,
  name,
  description,
  isActive,
  yardBlockAssignments: yardBlockAssignments ?? [],
  maxStackingHeight,
  maxLiftWeight,
  isOwned,
})

const mapDtoToFormValues = ({
  id,
  name,
  description,
  equipmentType,
  isActive,
  maxStackingHeight,
  maxLiftWeight,
  workAreaEquipments,
  isOwned,
}: EquipmentDto): EquipmentFormProfile => ({
  id,
  name,
  description: description ?? '',
  equipmentType,
  isActive,
  maxStackingHeight,
  maxLiftWeight,
  isOwned,
  yardBlockAssignments:
    workAreaEquipments
      ?.filter(x => x.yardBlockId)
      ?.map(
        wa =>
          ({
            yardBlockId: wa.yardBlockId,
            bays: wa.assignedBays,
          }) as YardBlockAssignmentDto,
      ) ?? [],
})

export const EquipmentFormMapper = {
  mapFormValuesToCreateDto,
  mapFormValuesToUpdateDto,
  mapDtoToFormValues,
}
